var map = {
	"./dotNet.svg": 8025,
	"./grafana.svg": 8868,
	"./maven.svg": 5027,
	"./microservice.png": 2592,
	"./mongodb.svg": 159,
	"./mysql.svg": 8135,
	"./springboot.svg": 6179,
	"./temporal.svg": 8745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9445;